
import {Constants,ArrayUtil} from '../Constants';

import { CoordGeodetic } from '../../service/coord-helper.service';
import { FdmPlugin, FdmPluginInterface } from './plugins';
import { Transform } from '4d-mapper';

const Cesium = (<any>window).Cesium;


export class CameraPositionsHandler extends FdmPlugin implements FdmPluginInterface {

    debug:boolean = Constants.debug_off;

    static meta = {
        label: 'PLUGINS.CAMERA_POSITIONS.LABEL',
        name: 'camera-positions-handler',
        translator: 'PLUGINS.CAMERA_POSITIONS',
        tooltip: 'PLUGINS.CAMERA_POSITIONS.TOOLTIP',

        category: FdmPlugin.category.internal,
        types: [ FdmPlugin.types.coordController, FdmPlugin.types.imageController ]
    };

    // visibility
    show:boolean = true;

    // local reference to coordinates
    coords:CoordGeodetic[] = null;

    // local reference to the current Transforms (photos)
    transforms:Transform[] = [];

    // basic stats
    maxHeight:number = 0;
    minHeight:number = 99999999;

    // mouse handler, as we do some interaction when hover/clicking images
    mouseHandler:any = null;

    hoveringOver:any = null;
    hoverTimer:number = 0;

    cameraType:string = 'Camera';
    cameraTypeId:number = null;

    coordHelper:any = null;

    init () {

        this.coordHelper = this.services.coordHelper;

        // we've got options
        this.setupOption ( 'entityType', [ 'Camera', 'GCP', 'Base station' ]);

        this.addEntityType ( 'GCP', {
            show: this.show,
            billboard : {
                image : 'assets/images/icons/gcp.png',
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                disableDepthTestDistance:1500,
                scale:0.5,
                scaleByDistance: new Cesium.NearFarScalar(0, 1.5, 1500, 0.4)
            },
        });

        this.addEntityType ( 'BaseStation', {
            show: this.show,
            billboard : {
                image : 'assets/images/icons/base-station.png',
                disableDepthTestDistance:1500,
                scale:1,
                scaleByDistance: new Cesium.NearFarScalar(0, 2.5, 1500, 0.3)
            },
        });

        this.addEntityType ( 'Camera', {
            show: this.show,
            billboard : {
                image : 'assets/images/icons/camera.png',
                disableDepthTestDistance:1500,
                scale:1,
                scaleByDistance: new Cesium.NearFarScalar(0, 2, 1500, 0.4)
            },
        });

        this.addEntityType ( 'CameraFile', {
            show: this.show,
            billboard : {
                image : 'assets/images/icons/camera-file.png',
                disableDepthTestDistance:1500,
                scale:1,
                scaleByDistance: new Cesium.NearFarScalar(0, 2, 1500, 0.4)
            },
        });

        this.addEntityType ( 'CameraUnknown', {
            show: this.show,
            billboard : {
                image : 'assets/images/icons/camera-unknown.png',
                disableDepthTestDistance:1500,
                scale:1,
                scaleByDistance: new Cesium.NearFarScalar(0, 2, 1500, 0.4)
            },
        });

        

/*
        this.addSubscription(
            this.mapService.onCesiumReady().subscribe ( _ => {

                // our own mouse handler to trap early clicks (to make sure we don't click on the possibly active cursor)
                this.mouseHandler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.scene.canvas);

                // set up left-down-click handler
                // this.mouseHandler.setInputAction((movement) => {
                // this.onClick(movement);
                // }, Cesium.ScreenSpaceEventType.LEFT_UP);

                // set up mouse movement handler
                this.mouseHandler.setInputAction((movement) => {
                    this.onMouseMove(movement);
                }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            
            })
        );
        */  }

    setEntityProperties ( e:any, state:string = 'normal', label:string = '' ) {
        // console.log ( '@', e, state, label );
        
        // safety measure as Cesium crashes on null's
        if ( !label) {
            label = ' ';
        }

        switch ( state ) {

            case 'hover': 
                e.point.outlineColor = Cesium.Color.BLACK;
                // e.label.text = ' ' + label + ' ';
                break;
            
            case 'selected':
                e.point.color = Cesium.Color.GOLD;
                e.point.outlineColor = Cesium.Color.BLACK.withAlpha(0.5);
                // e.label.text = ' ' + label + ' ';
                break;
                
            case 'error':
                e.point.color = Cesium.Color.RED.withAlpha(0.9); 
                e.point.outlineWidth = 0;
                break;
            
            case 'converted':
                e.point.color = Cesium.Color.YELLOW;
                e.point.pixelSize = 15; 
                e.point.outlineColor = Cesium.Color.BLUE;
                e.point.outlineWidth = 3;
                break;
            
            case 'normal':
            default:
                e.point.color = Cesium.Color.WHITE;
                e.point.outlineColor = Cesium.Color.GRAY;
                e.point.outlineWidth = 3;
                // e.label.text = ' ';
                break;
        }  
    }

    stateFromTransform ( t:Transform ) {
        if ( t['isSelected'] ) {
            return 'selected';
        } else if ( t['hasError'] ) {
            return 'error';
        }
        return 'normal';
    }

    getProps ( coord:CoordGeodetic = null ) {
        let props = null;
        if ( coord ) {
            props = [
                { key: 'Name', value: coord.name },
                { key: 'Latitude', value: coord.lat },
                { key: 'Longitude', value: coord.long },
                { key: 'Height', value: coord.height },
                { key: 'Source', value: coord.source },
                { key: '--', value: '' },
                { key: 'Converted', value: coord.isConverted ? true : false },
                { key: 'Projected', value: coord.isProjected ? true : false },  
            ];

            props.push ( { key: 'Swapped?', value: coord.isSwapped } );
            props.push ( { key: 'EPSG code', value: coord.epsgCode } );

            if ( coord.isProjected ) {
                props.push ( { key: 'projectedX', value: coord.projected_x } );
                props.push ( { key: 'projectedY', value: coord.projected_y } );
            }
            if ( coord.isConverted ) {
                
                props.push ( { key: 'EPSG spec', value: { popup:true, show: false, value: coord.isConverted } } );
                props.push ( { key: 'proj4', value: { popup:true, show: false, value: coord.isConvertedHere } } );
            }
        }
        return props;
    }

    /*
    // overwrite what happens when we click the map
    clickedMap(movement: any, rightClick: boolean, checkedPosition):ClickDisplay { 
        // console.log ( '----', this.cameraType, this.cameraTypeId, movement, rightClick, checkedPosition, this );
        this.onClick(checkedPosition);
        return ClickDisplay.None; 
    }
*/
    onClick ( check:any = null ) {

        // this.inj1.updateInfoBox ( 40 + this.cameraTypeId, { show:false, holdStill:false } );

        if ( check && check.feature ) {

            // let entitiy = check.feature;

            let tid = check.feature.hasOwnProperty('_transformId') ? check.feature._transformId : null;
            let cid = check.feature.hasOwnProperty('_coordId') ? check.feature._coordId : null;

            console.log ( '# tid=['+tid+'] cid=['+cid+'] cameraTypeId=['+this.cameraTypeId+']' );

            if ( tid !== null ) {
                let t = this.transforms.find ( t => t.id == tid );
                // console.log ( '## tid,tr', tid, t );

                if ( t && t['canonicalCoords'] ) {

                    let coord = t['canonicalCoords'];
                    let cart = { x: coord.x, y: coord.y, z: coord.z };
                    let props = this.getProps ( coord );

                    // this.inj1.updateInfoBox ( 40 + this.cameraTypeId, { show:true, coord: cart, holdStill:true, text: 'Camera coord: ' + coord.name, props: props } );
                    
                }

            } else if ( cid !== null ) {

                let coord = this.coords.find ( c => c.id == cid );
                // console.log ( '## cid,coord', cid, coord, this );

                if ( coord ) {

                    let cart = { x: coord.x, y: coord.y, z: coord.z };
                    let props = this.getProps ( coord );
                    
                    // this.inj1.updateInfoBox ( 40 + this.cameraTypeId, { show:true, offset_y: -60, coord: cart, holdStill:true, text: 'GCP coord: ' + coord.name, props: props } );
                }
                
            }
            
        }

        // this.inj1.refreshInfoBoxes();
    }

    onMouseMove ( movement:any = null ) {
        
        // console.log ( '@@@', movement );
        let entity = this.pickTransformEntity ( movement.endPosition );

        if ( entity ) {

            // if not set
            if ( this.hoveringOver !== entity ) {

                this.setEntityProperties ( entity, 'hover', entity._transformId );
                this.hoveringOver = entity; 
                this.hoverTimer = 0;
            }
        }

        // defaults
        if ( this.hoveringOver && this.hoverTimer++ > 4 ) {

            let t = this.transforms.find ( t => t.id == this.hoveringOver._transformId );

            if ( t ) {
                this.setEntityProperties ( this.hoveringOver, this.stateFromTransform ( t ) );
                this.hoveringOver = null;
            }

        }

    }

    updateCoords ( coords:CoordGeodetic[] = null, cameraType:string = 'Camera', transforms:Transform[] = null ) {

        if ( coords ) {
            this.coords = coords;
        }

        if ( cameraType ) {
            this.cameraType = cameraType;
        }

        if ( transforms ) {
            this.transforms = transforms;
        }

        
        this.onClick ( null );

        this.wipe();

        let points = [];

        if ( ! coords ) {
            return;
        }

        let counter = 0;
        

        this.coords.forEach ( p => {

            let cart = this.coordHelper.toCartesian(p);

            let config = this.getEntityType ( this.cameraType, {
                name: 'c ' + p.transformId,
                position: cart,
                show: this.show
            });

            // console.log ( '@', this.cameraType, cameraType, config );

            if ( config ) {
                this.cameraTypeId = config._eid;
                let id = counter + ( config._eid * 5000 );
                p.id = id;
                // p.timestamp = '['+id+'] ' + this.cameraTypeId;
                // p.type = config;
                let e = this.services.mapService.viewer.entities.add ( config );
                e['_transformId'] = p.transformId;
                e['_coordId'] = id;
                // console.log ( '!', e);
                // if ( e && e.billboard) { e.billboard.eyeOffset = new Cesium.Cartesian3(0, 0, config._eid - ( config._eid * 2 ) ); }
                points.push ( e );
                counter++;
            }
            
        });

        this.entity ( 'primary', points );
    
        this.showHide();
    }

}
